jQuery(function() {

  var setTaxCode = function(element, country, existingValue){
    existingValue = existingValue ? existingValue : element.val();
    jQuery.get(
      '/stripe_tax_codes/'+ country ,
      data => {
        // if (data.results.length > 0){
          element.html('');
        // }

        if (existingValue) {
          if (!data.results.find(function(a){ return a.id == existingValue }) ){
            data.results.push({id: existingValue, text: existingValue });
          }
          data.results.push({id: '', text: '' });
        }
        element.select2({
          data: data.results,
          allowClear: true,
          language: {
            noResults: function() {
              return 'No values found';
            },
          }
        });
        element.val(existingValue).trigger("change");
      }
    );
  }

  jQuery('.country').each(function(){
    jQuery(this).select2({
        allowClear: true,
    });

    if ( this.value ){
      setTaxCode(jQuery('.tax_type'), this.value, jQuery('.tax_type').val());
    }
  });

  //County Changed
  jQuery('.country').on("change", function (ele) {
    var taxSel = jQuery('.tax_type');

    taxSel.val(null).trigger('change');

    if (this.selectedIndex < 1){
      taxSel.select2();
      return; //done
    }
    setTaxCode(taxSel, this.value);
  });


  jQuery('.country').on("select2:clear", function () {
    var taxSel = jQuery('.tax_type');
    taxSel.val(null).trigger('change');
    taxSel.html('');
  });

});
